import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateSEO, buildMetadata } from '../utils/seo';
import { SEOContext } from '../context/SEOContext';

/**
 * Custom hook for managing SEO meta tags
 * 
 * @param {Object} seoData - SEO configuration for the page
 * @param {string} seoData.title - Page title
 * @param {string} seoData.description - Page description
 * @param {string} seoData.keywords - Page keywords (optional)
 * @param {string} seoData.image - Social sharing image URL (optional)
 * @param {string} seoData.type - Open Graph type (default: 'website')
 */
const useSEO = (data) => {
      const location = useLocation();
      const collect = useContext(SEOContext);
      const metadata = buildMetadata(data, location.pathname);
      if (collect) collect(metadata);
      const serialized = JSON.stringify(metadata);
      useEffect(() => {
            updateSEO(JSON.parse(serialized));
      }, [serialized]);
};

export default useSEO;
